import NoteUnpostedCommentIndicatorContainer from './NoteUnpostedCommentIndicatorContainer';

export default NoteUnpostedCommentIndicatorContainer;